import "./component.scss";

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slider", "next", "prev"];

  connect() {
    this.slideWidth = 108; // 6.75rem in px
    this.slidesToMove = 3;
    this.gap = 16; // $spacing-s in px

    // Add scroll event listener
    this.sliderTarget.addEventListener(
      "scroll",
      this.updateButtonStates.bind(this)
    );
    // Initial button state update
    this.updateButtonStates();
  }

  disconnect() {
    // Clean up event listener
    this.sliderTarget.removeEventListener(
      "scroll",
      this.updateButtonStates.bind(this)
    );
  }

  updateButtonStates() {
    const isAtStart = this.sliderTarget.scrollLeft <= 0;
    const isAtEnd =
      this.sliderTarget.scrollLeft >=
      this.sliderTarget.scrollWidth - this.sliderTarget.clientWidth;

    this.prevTarget.disabled = isAtStart;
    this.nextTarget.disabled = isAtEnd;
  }

  next() {
    const currentScroll = this.sliderTarget.scrollLeft;
    const slideWidth = this.slideWidth + this.gap;
    const newScroll = currentScroll + slideWidth * this.slidesToMove;

    this.sliderTarget.scrollTo({
      left: newScroll,
      behavior: "smooth",
    });
  }

  prev() {
    const currentScroll = this.sliderTarget.scrollLeft;
    const slideWidth = this.slideWidth + this.gap;
    const newScroll = currentScroll - slideWidth * this.slidesToMove;

    this.sliderTarget.scrollTo({
      left: newScroll,
      behavior: "smooth",
    });
  }
}
